import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { EntityUtils } from '@/common/utils/EntityUtils';
import { useCallback } from 'react';

export const TestRunList = ({ testId }) => {

  const augRowsReq = useCallback(EntityUtils.parentFilterAugRowsReq('TEST', testId), [testId]);

  return <EntityList entity="TEST_RUN" augRowsReq={augRowsReq} />
}